<template>
    <div id="landing-banner">
        <!--=====================================-->
        <!--=        Banner Area Start         =-->
        <!--=====================================-->
        <section class="banner banner-style-5 mb--100">
            <div class="container p-5">
                <div class="row">
                    <div class="col-sm-12 col-md-8 col-xl-8 col-xxl-7 align-self-center">
                        <div class="banner-content">
                            <h1 class="subtitle primary mb-0" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">¿Cómo medimos el impacto?</h1>
                            <h2 class="white font-weight-100" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">
                                Descubre el <span class="bold">impacto</span> que junt@s hemos creado.
                            </h2>
                        </div>
                    </div>
                    <div class="col-sm-1 col-md-4 col-xl-4 col-xxl-5 col-sm-hidden">
                        <div class="banner-thumbnail">
                            <div class="large-thumb-2" data-sal="slide-left" data-sal-duration="1000" data-sal-delay="200">
                                <img src="https://cdn.redgirasol.com/nuevo_portal/logos/logo-ods-white.png" alt="Laptop">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "LandingBanner",
    components: {
        
    }
}

</script>

<style scoped>
.banner-style-5 {
    padding: 200px 40px 0;
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/banners/banner-impacto.png") !important;
}

.banner.banner-style-5::after {
    background-color: transparent;
}

.align-self-center {
    align-self: center;
}

</style>